(function () {
  function getInventoryData() {
    var el = document.querySelector('[id^="VariantInventory-"]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch(e) { return null; }
  }

  function applyLimit(variantId) {
    var data = getInventoryData();
    var input = document.querySelector('.quantity__input[type="number"]');
    if (!input) return;
    if (!data || !variantId || data[variantId] === undefined) {
      input.removeAttribute('max');
      return;
    }
    var inv = parseInt(data[variantId]);
    if (isNaN(inv) || inv <= 0) { input.removeAttribute('max'); return; }
    input.setAttribute('max', inv);
    if (parseInt(input.value) > inv) input.value = inv;
  }

  function getCurrentVariantId() {
    var match = location.search.match(/variant=(\d+)/);
    if (match) return match[1];
    var h = document.querySelector('input[name="id"]');
    return h ? h.value : null;
  }

  setTimeout(function() { applyLimit(getCurrentVariantId()); }, 400);

  var orig = history.replaceState;
  history.replaceState = function () {
    orig.apply(this, arguments);
    setTimeout(function() { applyLimit(getCurrentVariantId()); }, 200);
  };

  document.addEventListener('input', function (e) {
    if (e.target.matches('.quantity__input[type="number"]')) {
      var max = parseInt(e.target.getAttribute('max'));
      if (!isNaN(max) && max > 0 && parseInt(e.target.value) > max) {
        e.target.value = max;
      }
    }
  });
})();
